module.exports = __webpack_public_path__ + "static/media/Internationalpic1@2x.d0e70a94.png";